import React from "react";

import { PageLoader, Pagination, Table } from "clearsense-ui/components";

const StewardsTable = ({
  columns,
  stewardData,
  stewardPagination,
  currentPage,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className="flex flex-col flex-grow p-2 cs-ui-table-background ">
      <Table
        fixedHeight
        rowData={columns.selected.length && stewardData}
        columnData={columns.selected}
        rowKey={record => record.key}
        data-cy="people-table"
      />
      <Pagination
        showResultsPerPage
        className="px-6 mt-auto"
        totalRecordsCount={stewardPagination?.total_pagination}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default StewardsTable;
